import { useCallback } from "react";
import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";
import { routesFlat } from "@routes";
import { BlackLogo } from "@assets/icons";
import { getBgColor, withScrollLogic } from "../../../helpers";
import { Toggle } from "../";
import useResizeObserver from "@/hooks/useResizeObserver";

function Header({
    scrollOpacity,
    isOpen,
    cycleOpen,
    topOffset = 0,
    onHeightChange,
}) {
    const currentRoute = useLocation();
    const bgColor = getBgColor(
        currentRoute.pathname,
        scrollOpacity,
        isOpen,
    );
    const handleResize = useCallback(
        (entry) => {
            const height =
                entry?.borderBoxSize?.[0]?.blockSize ??
                entry?.contentBoxSize?.[0]?.blockSize ??
                entry?.contentRect?.height ??
                0;
            onHeightChange?.(height);
        },
        [onHeightChange],
    );

    const headerRef = useResizeObserver(handleResize);

    return (
        <div
            ref={headerRef}
            className={parentContainer}
            style={{ ...bgColor, top: `${topOffset}px` }}
        >
            <Link
                to={routesFlat.landing}
                className={`flex ${isOpen ? "fixed" : ""}`}
                onClick={isOpen ? cycleOpen : null}
            >
                <BlackLogo
                    withText={true}
                    className="ml-4 h-20 max-w-[150px]"
                />
            </Link>
            <Toggle isOpen={isOpen} cycleOpen={cycleOpen} />
        </div>
    );
}

const parentContainer = clsx(
    "fixed z-40 flex w-full min-h-[80px] justify-between lg:hidden",
);

export default withScrollLogic(Header);
